import { Injectable } from '@angular/core';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';
import { Platform } from '@ionic/angular';
import { Device } from '@ionic-native/device/ngx';

import * as Constants from 'src/app/app.constants';
import { AuthService } from './services/auth.service';
import { v4 as uuidv4 } from 'uuid';
import { ReturnStatement } from '@angular/compiler';




@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private googleAnalyticsId: string | null = null;

  initializedService: Boolean = false;


  initialized: Boolean = false;
  isCookieAccepted: Boolean = null;

  uuid:any = null;

  isDesktopVersion = null;

  anonymizeRouterUrls: string[] = [
    '/smart-redirect',
    '/actions/home',
    '/mail-validation'
  ];

  constructor(
    private platform: Platform,
    public device: Device, 
    private ga: GoogleAnalytics,
    public auth: AuthService,
    private storageService: Storage,
    private router: Router
  ) {

  }

  initializeService() {
    return new Promise((resolve) => {
      this.isCookieConsentAccepted().then( res => {
        this.getUUID().then( res => {
          resolve(res);
        });
      });
    });
  }

  

  getUUID() {
    return new Promise((resolve) => {

      if (this.device != null && this.device.uuid != null ) {
        this.uuid = this.device.uuid;
        resolve( this.device.uuid );

      } else {
        this.storageService.get(Constants.LOCALE_UUID).then(result => {

          if ( result != null ) {
            this.uuid = result;  
            resolve( result );

          } else {
            
            let newUuid = uuidv4();
            this.storageService.set(Constants.LOCALE_UUID, newUuid ).then( res => {

            }, err => {
              console.error('STORAGE KO');
            });
            this.uuid = newUuid;
            resolve( newUuid );
  
          }
        }, err => {
          let newUuid = uuidv4();
          this.storageService.set(Constants.LOCALE_UUID, newUuid ).then( res => {
          }, err => {
            console.error('STORAGE KO');

          });
          this.uuid = newUuid;
          resolve( newUuid );
        
        });

      }
    
    });
    
  }









  // true se ho accettato il consenso 
  // false se ho negato il consenso
  // null se non ho risposto al consenso
  isCookieConsentAccepted() {

    return new Promise((resolve) => {
      this.storageService.get(Constants.COOKIE_CONSENT).then(result => {

        if ( result == null || result[1] == null || new Date().getTime() - new Date(result[1]).getTime() > Constants.COOKIE_CONSENT_DURATION_DAYS * 24 * 60 * 60 * 1000 ) {
          
          this.isCookieAccepted = null;
          console.log('Cookie expired - I have to request it');
          resolve( null ); 

        } else {
          this.isCookieAccepted = result[0] ;
          resolve( result[0] );
          
        }
      },
      error => {
        this.isCookieAccepted = null;
        resolve( null ); 
     });

    });
  }


  setCookieConsent( value ) {
    return new Promise((resolve) => {
      this.storageService.set(Constants.COOKIE_CONSENT, [value , new Date()]).then(result => {
        this.isCookieAccepted = true;
        resolve( true );
      },
      error => {
        this.isCookieAccepted = null;
        resolve( null );
     });

    });
  }



  //IMPROVE - E' necessario accedere ogni volta allo storage per avere questa informazione
  // oppure potrei evitarlo?
  isSiteDesktopVersionSelected() {

    return new Promise((resolve) => {
      this.storageService.get(Constants.RICHIEDI_SITO_DESKTOP).then(result => {

        if ( result == null || 
          result[1] == null || 
          new Date().getTime() - new Date(result[1]).getTime() > Constants.RICHIEDI_SITO_DESKTOP_DURATION_DAYS * 24 * 60 * 60 * 1000 ) {
            
          if (this.platform.is('desktop')) {
            this.isDesktopVersion = true;
          } else {
            this.isDesktopVersion = false;
          }
        } else {
          if (result[0] == 'desktop' ) {
            this.isDesktopVersion = true;
          } else {
            this.isDesktopVersion = false;
          }
        }
        resolve( true );

      },
      error => {
        if (this.platform.is('desktop')) {
          this.isDesktopVersion = true;
        } else {
          this.isDesktopVersion = false;
        }
        resolve( null );
      });
    });
  }



  setSiteDesktopVersion( value ) {
    return new Promise((resolve) => {
      this.storageService.set(Constants.RICHIEDI_SITO_DESKTOP, [value , new Date()]).then(result => {
       this.isDesktopVersion = 'desktop' === value;
       resolve( true );
      },
      error => {
        this.isDesktopVersion = 'desktop' === value;
        resolve( null );
     });

    });
  }





  private gtag(...args): void {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push(arguments);
  }

  public loadScript(): void {
    if (this.googleAnalyticsId) {
      (function(i, s, o, g, r, a, m) {
        a = s.createElement(o);
        m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(
        window,
        document,
        'script',
        'https://www.googletagmanager.com/gtag/js?id=' + this.googleAnalyticsId
      );
      window['dataLayer'] = window['dataLayer'] || [];

      //console.log('AnalyticsService - load js');
    }
  }

  //Inizializzo Analytics usando GA per MOBILE e GTAG per WEB
  public initialize(): void {

    if (this.platform.is('cordova')) {
      if (!this.initialized) {        
        this.googleAnalyticsId = Constants.ANALYTICS_TRACKER_ID;

        this.ga.setAnonymizeIp(true);

        this.ga
        .startTrackerWithId(this.googleAnalyticsId)
        .then(() => {
          console.log('Google analytics is ready now for Mobile');
          this.initialized = true;
        })
        .catch(e => console.log('Error starting GoogleAnalytics', e));   
        
      }
    } else {

      if (!this.initialized) {

        this.googleAnalyticsId = Constants.ANALYTICS_TRACKER_ID; 
        this.loadScript();
        this.gtag('js', new Date());
        this.initialized = true;
        //console.log('Google analytics is ready now for Web');

      }
    }

  }

  public sendCustomDimensions(
    configurationMapping: any,
    customDimensionValues: any
  ) {
    if (this.initialized) {
      this.gtag('config', this.googleAnalyticsId, {
        send_page_view: false,
        custom_map: configurationMapping
      });
      this.gtag('event', 'custom_dimension_send', customDimensionValues);
    }
  }
  


  /**
   * 
   * @param url 
   * Metodo per tracciare la navigazione in locale in caso di utente Anonimo
   */

  async addLocalNavigation( url ) {


    //console.log('Add Local Navigation' + url);
    if (this.auth.isAuthenticated()) {
       return false;  
    }

    if ( this.isCookieAccepted == null ) {
      await this.isCookieConsentAccepted();
    }

    this.isCookieConsentAccepted().then(
      (accepted: any) => {
        if ( accepted == null ) {
               

        } else {

          if ( accepted) {

            let userId = null;
      
            this.getUUID().then( (res: any) => {
              userId = res;

              let localNavigation = [];
              let instanceNavigation = [new Date().toISOString(), url , userId ];

              this.storageService.get( Constants.RACC_ENGINE_STORAGE_NAME ).then(
                result => {
                  if (result) {
                    localNavigation = result.slice( - Constants.RACC_ENGINE_STORAGE_LIMIT_RECORD );
                  } else {
                    localNavigation = [];
                  }

                  localNavigation.push( instanceNavigation );
                  this.storageService.set(Constants.RACC_ENGINE_STORAGE_NAME, localNavigation).then( res => {

                  }, err => {
                    console.error(err);
        
                  });             
                },
                error => {
                  console.error(error);

                  localNavigation = [];
                  localNavigation.push( instanceNavigation );
                  this.storageService.set(Constants.RACC_ENGINE_STORAGE_NAME, localNavigation).then( res => {

                  }, err => {
                    console.error(err);
                  });
                }
              );
            });
          } else {
            console.log('ANALYTICS - MOTORE DI RACCOMANDAZIONE LOCALE - Non ti traccio perchè NON hai accettato i cookie.');

          }
        }
      }); 
  }

  public sendPage(pageTitle, pageUrl): void {
    this.isCookieConsentAccepted().then(
      (accepted: any) => {
        if ( accepted == null ) {               

        } else {
          if ( accepted) {
    
              if (this.initialized  ) {          
                let userId = null;
                if (this.auth.isAuthenticated()) {
                  if ( this.auth.user && this.auth.user.sub ) {
                    userId = this.auth.user.sub;
                  }
                }
          
                //Platform is MOBILE
                if ( this.platform.is('cordova')) {
          
                  if (userId != null) {
                    this.ga.setUserId( userId );
                  }
                  this.ga.trackView( pageTitle + ' ' + pageUrl );
          
                } else {
          
                  // WEB
                  if (userId != null) {
                    this.gtag('set', { user_id: userId });
                    this.gtag('config', this.googleAnalyticsId, {
                      page_title:  pageTitle,
                      page_path:  pageUrl,
                      user_id:    userId
                    });
                  } else {

                    console.log('Analytics: Invio la pagina:' + pageTitle);
                    
                    this.gtag('config', this.googleAnalyticsId, {
                      page_title:  pageTitle,
                      page_path:  pageUrl
                    });
                  }

            

                }
          
              }  else {
                console.error('Non invio PAGE , perchè non è inizializzato');
              }

          }
        }
      });           
  }

  public sendApplyOnlineEvent(): void {
    if (this.initialized) {
      this.gtag('event', 'ApplyOnlineClick', {
        send_to: this.googleAnalyticsId,
        event_category: 'ApplyOnlineBtn',
        event_label: 'ApplyOnline'
      });
    }
  }

  public sendGaEvent(action: string, category: string, label: string): void {
    if (this.initialized) {

      let userId = null;
      if (this.auth.isAuthenticated()) {
        if ( this.auth.user && this.auth.user.sub ) {
          userId = this.auth.user.sub;
        }    
      }

      if ( this.platform.is('cordova')) {
        if (userId != null) {
          this.ga.setUserId( userId );
          console.log('sendGaEvent set userId  &uid ' + userId);
        }

        this.ga.trackEvent( category, action, label );

      } else {

        this.gtag('event', action, {
          event_category: category,
          event_label: label,
          send_to: this.googleAnalyticsId
        });

      }

    } else {
      console.error('Non invio EVENTO , perchè non è inizializzato');
    }
  }
}
